export const initialEntitlementState = {
    remainingEntitlement: 0.5,
    totalEntitlement: 0.5,
};
